// extracted by mini-css-extract-plugin
export default {"youtube":"youtube_youtube__jlIuP"};